define(
	'MHI.AddressCustomization.ShoppingEntry'
,   [
		'MHI.AddressCustomization.Utils',
		'underscore'
	]
,   function (
		MHIUtils,
		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			window.localStorage.setItem('newAddresses', JSON.stringify([])); //clearing local storage
			
			//reset back customer address if customer leave checkout without placing order
			var userprofilecomponent = container.getComponent("UserProfile");
			userprofilecomponent.getUserProfile().then(function(profile) {
			    if(profile.isloggedin){
					var addresses = profile.addressbook;

					var profileBillAddress = _.find(addresses, function(address){
						return address.defaultbilling === 'T';
					});
					var profileShipAddress = _.find(addresses, function(address){
						return address.defaultshipping === 'T'
					});
					if(!_.isEmpty(window.sessionStorage.getItem('shipaddress')) || !_.isEmpty(window.sessionStorage.getItem('billaddress'))){
						MHIUtils.resetProfileAddresses(profileShipAddress, profileBillAddress);
					}
				}
			});
		}
	};
});
